export default {
  Configurations: 'الإعدادات',
  'Terminal brand': 'العلامة التجارية للجهاز',
  'Terminal model': 'نوع الجهاز',
  'Refund category': 'فئة الاسترداد',
  'Payment type accepted': 'نوع الدفع المقبول',
  // Settlement
  'Settlement frequency': 'تكرار التسوية',
  'Settlement first day': 'أول يوم تسوية',
  'Settlement second day': 'ثاني يوم تسوية',
  'Cut-off day': 'يوم القطع',
  'Cut-off time': 'وقت القطع',
  Daily: 'يومي',
  'Weekly once': 'مرة واحدة في الأسبوع',
  'Weekly twice': 'مرتين في الأسبوع',
  Monthly: 'شهري',
  Fortnightly: 'كل أسبوعين',
};
